import classNames from 'classnames';
import { Card, Spin } from 'antd';
import type { ReactNode } from 'react';
import type { CardProps } from 'antd';
import logoUrl from '@images/logo.png';

import { RxChevronLeft } from 'react-icons/rx';
import type { themeColourAttributes } from '../../utils/constants';

export type StyledCardProps = CardProps & {
    borderColor?: keyof typeof themeColourAttributes;
    loading?: boolean;
    fill?: boolean;
    showLogo?: boolean;
    onBack?: () => void;
    backLabel?: ReactNode;
    backIcon?: ReactNode;
};

export const StyledCard = ({
    borderColor,
    className,
    loading,
    fill,
    showLogo,
    onBack,
    backLabel = 'Back',
    backIcon = <RxChevronLeft size={18} />,
    ...props
}: StyledCardProps) => {
    const cardClasses = classNames(
        'styled-card',
        { [`styled-card-bordered-${borderColor}`]: borderColor, [`fill`]: fill },
        className
    );
    const extra = loading ? <Spin /> : null;
    let title = props.title;
    if (showLogo) {
        title = (
            <div>
                {onBack ? (
                    <a className="ant-card-back-link" color="blue" onClick={onBack}>
                        {backIcon}
                        {backLabel}
                    </a>
                ) : null}
                <div className="ant-card-head-logo">
                    <img src={logoUrl} className="logo" alt="Ameli Voice Demonstrator Logo" />
                </div>
                {props.title}
            </div>
        );
    }

    return <Card className={cardClasses} extra={extra} {...props} title={title} />;
};
